export const DAILY_CIRCLE_TRANSLATIONS = {
  fr: {
    "daily_circles.nav": "Cercles",
    "daily_circles.title": "Cercles du jour",
    "daily_circles.create": "Créer un cercle",
    "daily_circles.unavailable": "Audio/vidéo temporairement indisponible",
  },
  en: {
    "daily_circles.nav": "Circles",
    "daily_circles.title": "Today’s Circles",
    "daily_circles.create": "Create a circle",
    "daily_circles.unavailable": "Audio/video temporarily unavailable",
  },
};
